export default "__VITE_ASSET__0eb144f2__"